import {Component, Input} from '@angular/core';
import {FormControl} from "@angular/forms";
import {BaseModalComponent} from "app/views/modal/base_modal.component";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {HelperService} from "app/lib/helper.service";
import {SupportService} from "app/support/support/support.service";
import {FormControlValidators} from "../../../models/validators/validator";
import {Transaction} from "../../../models/billing.model";
import {SupportModalForm} from "../../../models/form";
import * as moment from 'moment-timezone';


const getAmountValidatorList  = amount => {
	return [
		FormControlValidators.lte(amount),
	];
};

const getDateToValidatorList = () => {
	return [
		FormControlValidators.date(),
	];
};


@Component({
	template: `
        <base-modal
                [title]="title"
                [isLoading]="isLoading"
                [isBtnOkActive]="isBtnOkActive"
                [form]="form"
        >
            <form [formGroup]="form">
                <div class="form-group">
                    <label for="name">ID оплаты</label>

                    <select
                            class="form-control"
                            formControlName="transactionId"
                            [formErrorIndicator]="transactionId"
                    >
                        <option *ngFor="let transaction of transactions" value="{{ transaction.transactionId }}">
                            {{  niceTransaction(transaction) }}
                        </option>
                    </select>
                </div>

                <div class="form-group">
                    <label for="name">Типа возврата</label>

                    <select
                            class="form-control"
                            formControlName="type"
                            [formErrorIndicator]="type"
                    >
                        <option *ngFor="let type of types" value="{{ type }}">
                            {{ 'adminstat.support.return paid.' + type | translate }}
                        </option>
                    </select>
                </div>

                <div class="form-group">
                    <label for="name">Сумма возврата</label>

                    <div class="input-group" [formErrorIndicator]="amount">
                        <input
                                type="text"
                                class="form-control"
                                formControlName="amount"
                                [readonly]="(type.value === 'warrantyPeriod' || type.value === 'secondPaid')"
                        />

                        <div class="input-group-append">
                            <span class="input-group-text" id="inputGroupPrepend">$</span>
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label for="name">Оставить тарифа</label>

                    <select
                            class="form-control"
                            formControlName="stayTariff"
                            [formErrorIndicator]="stayTariff"
                    >
                        <option *ngFor="let stayTariff of stayTariffs" value="{{ stayTariff }}">
                            {{ 'adminstat.support.return paid.' + stayTariff | translate }}
                        </option>
                    </select>

                    <datepicker
                            formControlName="dateTo"
                            [disabledPast]="true"
                            [hidden]="stayTariff.value !== 'manual'"
                            [formErrorIndicator]="dateTo"
                    ></datepicker>
                </div>

                <div class="form-group">
                    <label for="name">Коментарий</label>
                    <textarea
							class="form-control"
							id="comment"
							formControlName="comment"
							[formErrorIndicator]="comment"
					></textarea>
                </div>
            </form>
        </base-modal>
	`
})
export class ReturnPaidComponent extends BaseModalComponent {
	@Input() providerNameList: string[] = [];
	@Input() roleNameList: string[] = [];
	@Input() transactions: Transaction[];

	isBtnOkActive = false;

	types: string[] = [
		'warrantyPeriod',
		'partialRefund',
		'secondPaid',
		'other',
	];

	stayTariffs: string[] = [
		'manual',
		'stay10days',
	];

	form = new SupportModalForm({
		transactionId: new FormControl('', [
			FormControlValidators.required(),
			FormControlValidators.minLength(4),
		]),
		type: new FormControl(),
		amount: new FormControl(),
		stayTariff: new FormControl(),
		dateTo: new FormControl(),
	});

	get transactionId() {
		return this.form.get('transactionId');
	}

	get type() {
		return this.form.get('type');
	}

	get amount() {
		return this.form.get('amount');
	}

	get stayTariff() {
		return this.form.get('stayTariff');
	}

	get comment() {
		return this.form.get('comment');
	}

	get dateTo() {
		return this.form.get('dateTo');
	}

	get transaction(): Transaction {
		const transactionId = parseInt(this.transactionId.value, 10);
		return this.transactions.find(i => i.transactionId == transactionId);
	}

	set transaction(transaction: Transaction) {
		this.transactionId.setValue(transaction.transactionId);
		this.amount.setValue(transaction.amount);
	}

	constructor(
		public activeModal: NgbActiveModal,
		public helper: HelperService,
		public supportService: SupportService
	) {
		super(activeModal);
	}

	ngOnInit() {
		const me = this;

		me.transactionId.valueChanges.subscribe(() => {
			const transaction = me.transaction;
			me.amount.setValue(transaction.amount);
		});

		me.type.valueChanges.subscribe(type => {
			if (type === 'partialRefund' || type === 'other') {

				// Валидаторы нужно сбрасывать всегда, иначе в нем замыкается значение amount из invoice.
				// При выборе инвойса с другой суммой, значение в валидаторе lte останется старым
				me.amount.setValidators(
					getAmountValidatorList(me.transaction.amount)
				);
				me.amount.updateValueAndValidity();

				return;
			}

			me.amount.setErrors(null);
			me.amount.setValidators(null);
		});
		me.type.setValue(this.types[0]);

		me.stayTariff.valueChanges.subscribe(stayTariff => {
			if (stayTariff === 'manual') {
				me.dateTo.setValidators(
					getDateToValidatorList()
				);
				me.dateTo.updateValueAndValidity();

				return;
			}

			me.dateTo.setErrors(null);
			me.dateTo.setValidators(null);
		});
		me.stayTariff.setValue(this.stayTariffs[0]);
	}

	niceTransaction(transaction) {
		return `${transaction.transactionId} - $${transaction.amount}, ${moment(transaction.transactionDate).format('YYYY-MM-DD HH:mm')}, ${transaction.tariffId}/${transaction.tariffVariant}`;
	}
}
